export const Policy = {
  U_PIC: 'upic_terms_of_service',
}
export const PolicySource = {
  SHIPBAE: 'SHIPBAE',
  EMAIL: 'EMAIL',
}
